export default __webpack_public_path__ + "static/media/GreenHouse1.9184f4de.jpg";